<template>
  <div class="profile-widget-component">
    <div ref="dashboard" class="profile-components-container">
      <div ref="profile_svg" class="dashboard-container">
        <div
          class="dashboard-svg-container"
          data-help-title="Der Tachometer"
          data-help="Hier siehst du deinen Gesamtfortschritt. Jede drei mal richtig beantwortete Frage zählt als gelernt."
        >
          <TheDashboard />
          <div class="profile-buttons-right-container">
            <div
              :class="['help-button', 'link', helpMode ? 'active' : '']"
              role="button"
              @click="toggleHelpMode"
            >
              <HelpButton />
            </div>
            <div class="mute-button link" role="button" @click="toggleMute">
              <MuteButtonOn v-if="mute" />
              <MuteButtonOff v-else />
            </div>
          </div>
          <div class="profile-buttons-container">
            <TheProfileButtons />
          </div>
        </div>
      </div>
      <div ref="profile_container" class="profile-info-container">
        <TheProgressTrack />
        <TheCar />
        <TheAnsweredQuestionsChart />
        <TheTimeSpentChart />
        <TheTrophyList />
        <TheTestsCompletedChart />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TheDashboard from "@/components/TheDashboard.vue";
import TheProgressTrack from "@/components/TheProgressTrack.vue";
import TheAnsweredQuestionsChart from "@/components/TheAnsweredQuestionsChart.vue";
import TheTimeSpentChart from "@/components/TheTimeSpentChart.vue";
import TheTestsCompletedChart from "@/components/TheTestsCompletedChart.vue";
import TheCar from "@/components/TheCar.vue";
import TheTrophyList from "@/components/TheTrophyList.vue";
import TheProfileButtons from "@/components/TheProfileButtons.vue";
import MuteButtonOn from "@/assets/Icon_leise.svg";
import MuteButtonOff from "@/assets/Icon_laut.svg";
import HelpButton from "@/assets/Icon_Fragezeichen.svg";

export default {
  name: "TheProfileWidget",
  components: {
    TheDashboard,
    TheProgressTrack,
    TheAnsweredQuestionsChart,
    TheTimeSpentChart,
    TheCar,
    TheTrophyList,
    TheTestsCompletedChart,
    TheProfileButtons,
    MuteButtonOn,
    MuteButtonOff,
    HelpButton,
  },
  props: {
    forceOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deg: -75,
      expanded: false,
      svgHeight: 0,
    };
  },
  computed: {
    rotation() {
      let deg = -75 + this.answers * 10;
      deg = deg > 75 ? 75 : deg;
      return "rotate(" + deg + " 130,180)";
    },
    buttonsTop() {
      if (this.svgHeight) return "top: " + (this.svgHeight - 55) + "px;";
      return "";
    },
    ...mapGetters(["user", "answers", "profileExpanded", "helpMode", "mute"]),
  },
  watch: {
    profileExpanded: function (newState, oldState) {
      let height = this.$refs.profile_svg.offsetHeight;
      if (newState) {
        let profileHeight = this.$refs.profile_container.offsetHeight;
        this.$refs.dashboard.style.height = height + profileHeight + "px";
      } else {
        this.$refs.dashboard.style.height = height + "px";
      }
    },
  },
  mounted() {
    let height = this.$refs.profile_svg.offsetHeight;
    this.svgHeight = height;
    if (!this.forceOpen) {
      this.$refs.dashboard.style.height = height + "px";
    } else {
      this.expanded = true;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    ...mapActions(["toggleHelpMode", "toggleMute"]),
  },
};
</script>

<style lang="scss" scoped>
.profile-widget-component {
  background: #000000;
  color: #ffffff;
  /*height: 260px;*/
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  overflow: hidden;
  transition: height 1s ease-in-out;

  #profile-expand-btn {
    position: absolute;
    bottom: 0;
    right: 50px;
    cursor: pointer;
  }

  .profile-components-container {
    width: 100%;
    transition: height 0.5s ease-in-out;

    .dashboard-container {
      width: 100%;

      .dashboard-svg-container {
        position: relative;

        .profile-buttons-right-container {
          position: absolute;
          left: 20px;
          bottom: 9%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;

          .link {
            user-select: none;
            cursor: pointer;

            svg {
              max-width: 32px;
              @media all and (max-width: 500px) {
                max-width: 24px;
              }
            }

            path {
              transition: fill 0.3s ease-in-out;
            }
            &:hover,
            &.active {
              path:not(.no-color) {
                fill: $green;
              }
            }
          }

          .help-button {
            margin-right: 7px;
          }

          .mute-button {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
          }
        }

        .profile-buttons-container {
          position: absolute;
          bottom: 9%;
          right: calc(100px - 80px);
          width: 115px;
          @media all and (max-width: 500px) {
            width: 80px;
          }
        }

        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }
  }

  .profile-info-container {
    width: 100%;
    svg {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .flex {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
  }

  .user-info-container {
    position: absolute;
    top: 80px;
  }

  p {
    margin: 0;
  }

  .logout-button {
    cursor: pointer;
  }

  #arrow {
    transition: all 1s ease-in-out;
  }
}
</style>
